export const ADD_DRIVER = 'scenes/ClientDetail/components/AddVehicleModal/add_driver'
export const UPDATE_DRIVER = 'scenes/ClientDetail/components/AddVehicleModal/update_driver'
export const DELETE_DRIVER = 'scenes/ClientDetail/components/AddVehicleModal/delete_driver'

export const ADD_CLIENT = 'scenes/ClientDetail/components/AddVehicleModal/add_client'
export const DELETE_CLIENT = 'scenes/ClientDetail/components/AddVehicleModal/delete_client'

export const RESET_STATE = 'scenes/ClientDetail/components/AddVehicleModal/reset_state'



// WEBPACK FOOTER //
// ./src/components/DriversForm/constants.js